export const sanitizeText = text => {
  return text.replace(/&#038;/g, "&");
};
